import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ProductosUni from './Productos';
import FooterPublic from '../../FooterPublic';
import { useSucursal } from '../../../../contexts/SucursalContext';

function BodyProductUni({ idCategoria, searchTerm }) {
    const { idSucursal: contextIdSucursal } = useSucursal(); // Obtenemos el idSucursal desde el contexto global
    const { idSucursal: paramIdSucursal } = useParams(); // Obtenemos el idSucursal desde los parámetros de la URL
    const idSucursal = paramIdSucursal || contextIdSucursal; // Prioridad: URL > Contexto

    // Verificar el valor de idSucursal en consola
    useEffect(() => {
    }, [idSucursal]);

    return (
        <div>
            <ProductosUni
                idCategoria={idCategoria}
                searchTerm={searchTerm}
            />
            <FooterPublic idSucursal={idSucursal} /> 
        </div>
    );
}

export default BodyProductUni;
